import React, { Fragment, useState } from "react";
import ReactEmoji from "react-emoji";

const DiscussionChatMessageItem = ({ user, message, deleteMessage }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Fragment>
      <div className="chat-body">
        <div className="chat-container">
          <div className="chat-user-container">
            <div className="chat-item-containers">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${message.avatar}`}
                className="chat-avi"
                alt="chatimage"
              />
            </div>
            <div className="chat-item-containers">
              <div className="chat-text">
                <span className="green mr-5">
                  {message.firstname} {message.lastname}:{"\n"}
                </span>
                {message.gif !== "" && (
                  <img
                    src={message.gif}
                    alt="message-gif"
                    className="gif-image"
                  />
                )}
                <span className="max-text-width">
                  {ReactEmoji.emojify(message.text)}
                </span>
              </div>
            </div>
          </div>
          {message.firstname !== "imeBOT" && !showModal && (
            <div className="chat-item-modal-containers">
              <div className="chat-user-info">
                <i
                  onClick={() => {
                    if (showModal) {
                      setShowModal(false);
                    } else {
                      setShowModal(true);
                    }
                  }}
                  className="fas fa-ellipsis-v mx-10 green cursor"
                ></i>
              </div>
            </div>
          )}
        </div>
        <div className="center">
          {message.firstname !== "imeBOT" && showModal && (
            <div className="chat-item-modal-containers">
              <div className="chat-user-info">
                <i
                  onClick={() => {
                    if (showModal) {
                      setShowModal(false);
                    } else {
                      setShowModal(true);
                    }
                  }}
                  className="fas fa-ellipsis-v mx-10 green cursor"
                ></i>
              </div>
              <div className="chat-modal">
                <ul className="modal-items">
                  {message.channelid === user.channelid && showModal && (
                    <li
                      onClick={() => deleteMessage(message.messageid, message)}
                      className="modal-item"
                    >
                      <i className="fas fa-times mx-5 white"></i>
                      Delete
                    </li>
                  )}
                  {message.channelid !== user.channelid && showModal && (
                    <li className="modal-item">
                      <i className="fas fa-flag mx-5 white"></i>
                      Report
                    </li>
                  )}
                  {message.channelid !== user.channelid && showModal && (
                    <li className="modal-item">
                      <i className="fas fa-ban mx-5 white"></i>
                      Block
                    </li>
                  )}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default DiscussionChatMessageItem;
